import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { authState } from 'rxfire/auth';
import { Observable, of, catchError, map, switchMap, take } from 'rxjs';
import { AuthService } from '@core/service/auth.service';
import { RedirectService } from '@core/service/redirectService.service';

@Injectable({
  providedIn: 'root',
})
export class AppHomeGuard {
  private router = inject(Router);
  private auth = inject(Auth);
  private authService = inject(AuthService);
  private redirectService = inject(RedirectService);

  canActivate(): Observable<UrlTree> {
    return authState(this.auth).pipe(
      take(1),
      switchMap((user) => {
        if (!user) {
          return of(this.router.parseUrl('/authentication/signin'));
        }

        return this.authService.loadLoggedUserProfile().pipe(
          map((me) =>
            this.router.parseUrl(this.redirectService.getDefaultHomeUrl(me))
          ),
          catchError(() =>
            this.authService.logout().pipe(
              map(() => this.router.parseUrl('/authentication/signin')),
              catchError(() => of(this.router.parseUrl('/authentication/signin')))
            )
          )
        );
      })
    );
  }
}
